import Text from '../../../../../components/Text'

const DocumentPill = ({ documentStatus }) => {
  switch (documentStatus) {
    case 'not_uploaded':
      return (
        <div className="border-gray-600 bg-gray-50 px-5 py-1 rounded-full border absolute top-3.5 left-5">
          <Text variant="body" size="small" tag="p" className="text-gray-600">
            Step {documentType === 'ds' ? 1 : 2}
          </Text>
        </div>
      )
    case 'under_review':
      return (
        <div className="border-yellow-600 bg-yellow-50 px-5 py-1 rounded-full border absolute top-3.5 left-3">
          <Text variant="body" size="small" tag="p" className="text-yellow-600">
            Under Review
          </Text>
        </div>
      )
    case 'approved':
      return (
        <div className="border-green-600 bg-green-50 px-5 py-1 rounded-full border absolute top-3.5 left-5">
          <Text variant="body" size="small" tag="p" className="text-green-600">
            Verified
          </Text>
        </div>
      )
    case 'pending':
      return (
        <div className="border-gray-400 bg-gray-50 px-5 py-1 rounded-full border absolute top-3.5 left-5">
          <Text variant="body" size="small" tag="p" className="text-gray-400">
            Pending
          </Text>
        </div>
      )
    case 'rejected':
      return (
        <div className="bg-[#E54848] px-5 py-1 rounded-full border absolute top-3.5 left-5">
          <Text variant="body" size="small" tag="p" className="text-white">
            Rejected
          </Text>
        </div>
      )
    default:
      return <></>
  }
}

export default DocumentPill
